import { isAvaiablePhoneNum } from "@Lib/common";
import { useCounter, useInterval } from "ahooks-v2";
import React, { useState } from "react";
export interface IVerificationCodeProps {
  /** 手機號 */
  mobile?: string;
  /** 當前狀態 */
  status: ECodeStatus;
  /** 自定義樣式名 */
  customeClassNames?: string;
  /** 開始階段文案 */
  initLabel?: string;
  /** 等待時文案後綴 */
  suffixLabel?: string;
  /** 結束文案 */
  successLabel?: string;
  /** 倒計時時間 - s */
  time?: number;
  /** 錯誤異常提示器 */
  tips?: any;
  /** 點擊回調 */
  onClick: (status: ECodeStatus) => void;
  /**  校驗規則 */
  validate?: () => ECodeStatus;
}

export enum ECodeStatus {
  /** 初始 */
  INIT,
  /** 不允許 */
  DISABLED,
  /** 等待發送 */
  PENDING,
  /** 發送完冷卻 */
  LOADING,
  /** 完成 */
  SUCCESS,
}

/** 倒計時組件 */
const VerificationCode: React.FC<IVerificationCodeProps> = (props: IVerificationCodeProps) => {
  const {
    status,
    customeClassNames,
    initLabel = "發送驗證碼",
    suffixLabel = "s",
    successLabel = "重新發送",
    time = 60,
    mobile,
    tips,
    validate,
    onClick,
  } = props;

  const [current, { dec, reset }] = useCounter(time, { min: 0, max: time });
  const [interval, setInterVal] = useState(0);
  const [isWorking, setIsWorking] = useState(false);

  useInterval(() => {
    if (!isWorking) {
      return;
    }
    if (current === 0) {
      reset();
      setInterVal(0);
      onClick(ECodeStatus.SUCCESS);
      setIsWorking(false);
      return;
    }
    dec();
  }, interval);

  const getCodeText = (): string => {
    switch (status) {
      case (ECodeStatus.INIT, ECodeStatus.DISABLED, ECodeStatus.PENDING): {
        return initLabel || "發送驗證碼";
      }
      case ECodeStatus.SUCCESS: {
        return successLabel || "重新發送";
      }
      case ECodeStatus.LOADING: {
        return current + suffixLabel;
      }
      default: {
        return initLabel || "發送驗證碼";
      }
    }
  };

  /** 校驗 */
  const handleClick = () => {
    if (!mobile) {
      tips?.("請輸入行動電話");
      onClick(ECodeStatus.DISABLED);
      return;
    }
    if (!isAvaiablePhoneNum(mobile)) {
      tips?.("請輸入正確的行動電話號");
      onClick(ECodeStatus.DISABLED);
      return;
    }
    if (validate) {
      const status = validate();
      onClick(status);
      return;
    }
    if (status === ECodeStatus.LOADING) {
      return;
    }
    onClick(ECodeStatus.PENDING);
    setIsWorking(true);
    setInterVal(1000);
  };

  return (
    <span className={customeClassNames} onClick={handleClick}>
      {getCodeText()}
    </span>
  );
};

export default VerificationCode;
